module.exports = __webpack_public_path__ + "static/media/no-profile-pic.911afe8a.svg";